import {ChangeDetectorRef, Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {HabilitationInaugurationDto} from '../../../forms/modules/hip/models/hip';

@Pipe({
  name: 'filterSearchHip'
})
export class FilterSearchHipPipe implements PipeTransform {
  constructor(private cdr: ChangeDetectorRef, private translate: TranslateService) {}

  transform(items: HabilitationInaugurationDto[], searchText: string, hipFilterMetadata): HabilitationInaugurationDto[] {
    if (!items) {
      hipFilterMetadata.count = 0;
      this.cdr.detectChanges();
      return [];
    }
    if (!searchText) {
      hipFilterMetadata.count = items.length;
      this.cdr.detectChanges();
      return items;
    }
    searchText = searchText.toLowerCase();
    const filteredItems = items.filter((programme: HabilitationInaugurationDto) => {
      const text = programme.title + ' ' + programme.faculty.name + ', ' + this.translate.instant('dashboard.study_programme_part.sp_subtitle.study_field') +
        programme.studyField + (programme.studyField2 ? '+' + programme.studyField2 : '');
      return text.toLowerCase().indexOf(searchText) !== -1;
    });
    hipFilterMetadata.count = filteredItems.length;
    this.cdr.detectChanges();
    return filteredItems;
  }

}
